import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";

export const icons = {
  rightIcon: <ChevronRightRounded fontSize="small" />,
  downArrowIcon: <KeyboardArrowDownRounded fontSize="small" />,
};
